import { useTrackers } from '@lalalilo/front-utils'
import { useIsP2IAPage } from '../../compagnon/routers/useIsP2IA'
import {
  GOOGLE_ANALYTICS_4_ID,
  GOOGLE_ANALYTICS_ID,
  GOOGLE_TAG_MANAGER_ID,
} from '../../config'
import { useIsUserInFrance } from '../../i18n/france'

export type Trackers = ReturnType<typeof useSharedTrackers>['trackers']

const trackersParameters = {
  trackerIds: {
    googleAnalyticsId: GOOGLE_ANALYTICS_ID,
    googleAnalytics4Id: GOOGLE_ANALYTICS_4_ID,
    googleTagManagerId: GOOGLE_TAG_MANAGER_ID,
  },
}

export const useSharedTrackers = () => {
  const isUserInFrance = useIsUserInFrance()
  const isP2iaPage = useIsP2IAPage()

  const trackers = useTrackers({
    isP2iaPage,
    isUserInFrance,
    trackersParameters,
  })

  return { trackers, trackersParameters }
}
